import React, {useState, useContext, useEffect} from 'react';
import {
    ModalProps
} from 'react-native';

import ReactNativeWebModal  from 'modal-enhanced-react-native-web';
import CustomSnackbar from './CustomSnackbar';

interface IModalProps extends ModalProps {
    isVisible: boolean;
    layout?: "fit-content" | "large";
    removeBackground?:boolean;
    children: any;

    onBackdropPress: ()=>void;
}
function Modal(props: IModalProps) {
    const [snackbar, setSnackbar] = useState<any>({ open: false });

    useEffect(() => {
        document.addEventListener('onShowAlert', (e) => {
            //@ts-ignore
            setSnackbar({ open: true, message: e?.detail.message, severity: e?.detail.severity });
        }, false);
    }, []);
    
    const closeSnackbar = () => {
        setSnackbar({ open: false });
    }

    let styleProps = props?.style;
    styleProps = Array.isArray(styleProps) ? styleProps : [styleProps];
    let size = null;
    let background={};
    if(!props.removeBackground) background = {backgroundColor:"white"};
    switch (props.layout) {
        default:
        case "large":
            size = {margin: 20, marginHorizontal: 50};
            break;
        case "fit-content":
            size = {flex: null, marginHorizontal: 'auto', marginVertical: 'auto', maxHeight: '94vh', maxWidth: '90vw'};
            break;
    }
    return <ReactNativeWebModal
        {...props}
        style={[{
            padding: 20,
            borderRadius: 16},
            size,
            background,
            ...styleProps
        ]}
    >
        {props.children}
        <CustomSnackbar open={snackbar.open} message={snackbar.message} handleClose={()=> closeSnackbar()} severity={snackbar.severity || 'info'} />
    </ReactNativeWebModal>

}


export default Modal;
